import * as ClientOAuth2 from "client-oauth2";

interface IExtendedRequestInit extends RequestInit {
    url: string
    headers?: any
}

export default class Auth {
    // OAuth2 client configuration

    public token: ClientOAuth2.Token | undefined;

    private AuthClient: ClientOAuth2;

    constructor(path?: string) {
        this.AuthClient = new ClientOAuth2({
            authorizationUri: process.env.REACT_APP_ADMIN_BYGGDATA_AUTH_BASE_URI! + "/connect/authorize",
            clientId: 'bdadmin',
            redirectUri: process.env.REACT_APP_ADMIN_BYGGDATA_REDIRECT_URI + (path || ""),
            scopes: ['bdkalk']
        });
        this.refreshToken();

        this.clearToken = this.clearToken.bind(this);
        this.fetch = this.fetch.bind(this);
        this.getLogInUri = this.getLogInUri.bind(this);
        this.getToken = this.getToken.bind(this);
        this.hasValidToken = this.hasValidToken.bind(this);
        this.refreshToken = this.refreshToken.bind(this);
    }

    public clearToken() {
        sessionStorage.removeItem("token");
        this.token = undefined;
    }

    public fetch(input: string, init?: RequestInit) {
        if (!this.token) {
            return Promise.reject("No authentication token found");
        }
        if (this.token.expired()) {
            return Promise.reject("Token expired");
        }

        const rInit: IExtendedRequestInit = {
            ...init,
            url: input
        };

        const request: RequestInit = this.token.sign(rInit);
        request.mode = "cors";
        return fetch(rInit.url, request);
    }

    public getLogInUri(options?: ClientOAuth2.Options) {
        return this.AuthClient.token.getUri(options);
    }

    public getLogOutUri() {
        return process.env.REACT_APP_ADMIN_BYGGDATA_AUTH_BASE_URI! + "/connect/endsession";
    }

    // Request an authentication token
    // location is the URL containing the hash from the authentication redirection
    public getToken(location: Location) {
        const self = this;
        return this.AuthClient.token.getToken(location).then(t => {
            sessionStorage.setItem("token", JSON.stringify(t.data));
            self.token = t
        });
    }
    
    public refreshToken() {
        const token = sessionStorage.getItem("token");
        if (token) {
            this.token = this.AuthClient.createToken(JSON.parse(token));
        }
    }

    public hasValidToken() {
        return !!this.token;
    }

}


// WEBPACK FOOTER //
// ./src/login/auth.ts